/** The workspace root's instructions for agents (exactly this name, case-sensitive, as OpenCode looks it up). */
export const AGENTS_MD = "AGENTS.md";
